import { ReactLenis, useLenis } from '@studio-freight/react-lenis'
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Anasayfa from './pages/Anasayfa';
import PageContainer from './pages/PageContainer';
import Hakkimizda from './pages/Hakkimizda';
import Iletisim from './pages/Iletisim';
import BlogHaberler from './pages/BlogHaberler';
import BizdenHaberler from './components/blog-haberler/BizdenHaberler';
import TeknikBilgilerVeMakaleler from './components/blog-haberler/TeknikBilgilerVeMakaleler';
import SektorelHaberler from './components/blog-haberler/SektorelHaberler';
import Sistemler from './pages/Sistemler';
import Detay from './pages/Detay';
import Projeler from './pages/Projeler';
import IcSistemler from './pages/IcSistemler';
import HomeCategory from './components/HomeCategory';
import GizlilikPolitikasi from './pages/GizlilikPolitikası';
import CerezPolitikasi from './pages/CerezPolitikasi';
import ProjelerInner from './pages/ProjelerInner';
import ProjelerInnerInner from './pages/ProjelerInnerInner';
import { useEffect } from 'react';
import Kataloglar from './pages/Kataloglar';




function ScrollToTop() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return null
}

function LenisScrollHandler() {
  const location = useLocation()
  const lenis = useLenis()

  useEffect(() => {
    if (!lenis) return

    // Scroll'u durdur
    lenis.stop()

    // Hemen en başa al
    lenis.scrollTo(0, { immediate: true })

    // 2 saniye sonra tekrar başlat
    const timeout = setTimeout(() => {
      lenis.start()
    }, 1000)

    return () => clearTimeout(timeout)
  }, [location.pathname])

  return null
}


function App() {
  const location = useLocation();
  

  return (
    <ReactLenis root>
           <ScrollToTop />
           <LenisScrollHandler />
      <div className="App relative ">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageContainer />} >
              <Route path="/" element={<Anasayfa />} />
              <Route path="/hakkimizda" element={<Hakkimizda />} />
              <Route path="/iletisim" element={<Iletisim />} />

              <Route path="/pdfs" element={<Kataloglar />} />

              <Route path="/projeler" element={<Projeler />} />
              <Route path="/projeler/:id1" element={<ProjelerInner />} />
              <Route path="/projeler/:id1/:id2" element={<ProjelerInnerInner />} />


              <Route path="/sistemler" element={<HomeCategory />} />
              <Route path="/sistemler/:id1" element={<Sistemler />} />
              <Route path="/sistemler/:id1/:id2" element={<IcSistemler />} />
              <Route path="/sistemler/:id1/:id2/:id3" element={<Detay />} />




              <Route path="/blog-haberler" element={<BlogHaberler />} >
                <Route path="bizden-haberler" element={<BizdenHaberler />} />
                <Route path="sektorel-haberler" element={<SektorelHaberler />} />
                <Route path="teknik-bilgiler-ve-makaleler" element={<TeknikBilgilerVeMakaleler />} />
              </Route>



              <Route path="/politikalar" >
                <Route path="gizlilik-politikasi" element={<GizlilikPolitikasi />} />
                <Route path="cerez-politikasi" element={<CerezPolitikasi />} />
              </Route>

            </Route>
          </Routes>
        </AnimatePresence>
      </div>
    </ReactLenis>
  );
}

export default App;
